import React from 'react';

import MecanicaVentas from 'components/Tvendo/Sale/QuotaBPartner/Mecanica/List.js';

export default function () {
  return <MecanicaVentas />;
}
